export const SERVER_URL = process.env.REACT_APP_SAVOR_SERVER
export const WORK_URL = process.env.REACT_APP_WORK_SERVER
export const MOMO_URL = process.env.REACT_APP_MOMO_URL
export const MOMO_SECRET = process.env.REACT_APP_MOMO_SECRET
export const MOMO_PARTNER_CODE = process.env.REACT_APP_MOMO_PARTNER_CODE

if (process.env.NODE_ENV === 'development') {
  const isLocalWork = /localhost|127\.0\.0\.1/.test(WORK_URL || '')
  const style = isLocalWork
    ? 'background:#2e7d32;color:#fff;padding:2px 6px;border-radius:3px'
    : 'background:#c62828;color:#fff;padding:2px 6px;border-radius:3px;font-weight:bold'
  console.log(
    `%c[ENV] WORK_URL = ${WORK_URL} ${isLocalWork ? '(LOCAL)' : '(REMOTE!)'}`,
    style
  )
  console.log(`%c[ENV] SERVER_URL = ${SERVER_URL}`, style)
}
